let dialogIdCounter = 1;
export class CpdlcDialog {
    constructor(message) {
        this.messages.push(message);
        this.status = message.status;
    }
    id = dialogIdCounter++;
    messages = [];
    status;
    static dialogIsClosed(dialog) {
        return dialog.messages.every((message) => message.status === "CLOSED");
    }
}
//# sourceMappingURL=cpdlcDialog.js.map